<script lang="ts">
	import Ban from '@lucide/svelte/icons/ban'
	import LoaderCircle from '@lucide/svelte/icons/loader-circle'
	import type { Snippet } from 'svelte'
	import { cn } from 'tailwind-variants'

	import { m } from '#lib/paraglide/messages.js'
	import ChainspectLogo from '~icons/brand/logo'

	let {
		class: className,
		loading = false,
		empty = false,
		children,
	}: {
		class?: string
		loading?: boolean
		empty?: boolean
		children: Snippet
	} = $props()
</script>

<div class={cn('relative', className)}>
	{#if loading}
		<div class="bg-card absolute inset-0 z-1 flex flex-col items-center justify-center">
			<LoaderCircle class="animate-spin" size="24" />
			<p class="mt-2 font-semibold">{m.chart_loading()}</p>
		</div>
	{:else if empty}
		<div class="bg-card absolute inset-0 z-1 flex flex-col items-center justify-center">
			<Ban size="24" />
			<p class="mt-2 font-semibold">{m.chart_no_data()}</p>
		</div>
	{/if}

	{@render children()}

	<ChainspectLogo
		class="text-muted-foreground pointer-events-none absolute top-1/2 left-1/2 w-5/6 -translate-x-1/2 -translate-y-1/2 pl-6 opacity-10 select-none sm:pl-0"
	/>
</div>
